export default __webpack_public_path__ + "static/media/1.5f7c95f7.jpg";